var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn-primary-cta btn-block",on:{"click":function($event){$event.preventDefault();return _vm.showModal.apply(null, arguments)}}},[_vm._v("\n  Invest\n")])}
var staticRenderFns = []

export { render, staticRenderFns }